import { ReactElement } from 'react';

import { FunctionField, TextField } from 'shared/react-admin/Fields';
import { OrderAdjustments } from 'types/embedded/orderAdjustments';

type Props = {
  label?: string | ReactElement | boolean;
  source: string;
  onClick: (id?: string) => void;
};

export const OrderAdjustmentsReportGatewayField: React.FC<Props> = ({ label, source, onClick }) => {
  return (
    <FunctionField
      label={label}
      render={(record: OrderAdjustments) => (
        <TextField
          onClick={() => onClick(record?.order?.gateway?.['@id'])}
          source={source}
          sx={{ textDecoration: 'underline', cursor: 'pointer', color: 'primary.main' }}
        />
      )}
      source={source}
    />
  );
};
